import { useT } from '../../i18n';
import { playerDisplayName } from '../../lib/playerName';

/**
 * A player's name as text — or «Slettet spiller» for a player whose person
 * erased their data (#1062, `lib/playerName.ts`). Renders a bare string so it
 * drops into any existing `<span>` without changing the layout.
 */
export function PlayerName({ player }: { player: { name?: unknown } | null | undefined }) {
  const t = useT();
  return <>{playerDisplayName(player, t('players.erased'))}</>;
}
